import { MAX_SOURCE_IMAGE_BYTES } from 'components/image/uploadErrors'
import React from 'react'
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material'
import { Folder } from '@mui/icons-material'
import { Controller } from 'react-hook-form'
import { FileUploader } from 'react-drag-drop-files'
import ImageCropDialog from 'components/image/ImageCropDialog'
import useImageUpload from 'components/image/useImageUpload'

const BusinessLogoUpload = ({
  control,
  error,
  name = 'logoUrl',
  placeholder = 'Business logo',
  uploadUrl,
  onSuccess,
  helperText = 'Choose an image up to 2 MB. We’ll optimize it before uploading.',
}) => {
  const {
    closeCropDialog,
    cropDialogOpen,
    handleCropComplete,
    handleImageSelect,
    imageToCrop,
    inputRef,
    isUploading,
    openFileDialog,
    processFile,
    rejectFileSize,
    rejectFileType,
    showHelperText,
    uploadStatus,
  } = useImageUpload({ uploadUrl, onSuccess })

  return (
    <>
      <FormControl fullWidth variant="outlined" margin="dense">
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <>
              <FileUploader
                handleChange={(file) => processFile(file, field.onChange)}
                name="file"
                types={['PNG', 'JPG', 'JPEG']}
                maxSize={MAX_SOURCE_IMAGE_BYTES / (1024 * 1024)}
                onSizeError={rejectFileSize}
                onTypeError={rejectFileType}
              >
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    error={Boolean(error)}
                    helperText={error?.message}
                    label={field.value == null ? placeholder : ''}
                    inputProps={{ disabled: true, readOnly: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {isUploading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <IconButton
                              aria-label="Choose business logo file"
                              onClick={openFileDialog}
                              size="small"
                              component="span"
                            >
                              <Folder />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    margin="dense"
                    value={field.value || ''}
                    sx={{ width: '100%' }}
                  />
                </Box>
              </FileUploader>
              <input
                accept=".png,.jpg,.jpeg"
                onChange={(event) => handleImageSelect(event, field.onChange)}
                ref={inputRef}
                type="file"
                style={{ display: 'none' }}
              />
              <ImageCropDialog
                open={cropDialogOpen}
                imageSrc={imageToCrop}
                onClose={closeCropDialog}
                onCropComplete={handleCropComplete}
              />
            </>
          )}
        />
      </FormControl>

      {showHelperText && (
        <Typography variant="caption" color="textSecondary">{helperText}</Typography>
      )}
      {uploadStatus && (
        <Typography style={{ color: uploadStatus.color, marginTop: 8 }}>
          {uploadStatus.message}
        </Typography>
      )}
    </>
  )
}

export default BusinessLogoUpload
